(function () {
  'use strict';

  const previousDisplay = new WeakMap();
  const relevantSelector = '.shopify-payment-button, quantity-breaks, quantity-input, input[name="quantity"]';

  function hasMultipleQuantity(form) {
    return Array.from(form.elements).some(input => {
      if (input.tagName !== 'INPUT' || input.name !== 'quantity' || input.matches(':disabled')) return false;
      const selected = input.type === 'radio' && input.checked && input.closest('quantity-breaks');
      const classic = input.type === 'number' && input.closest('quantity-input');
      const quantity = Number(input.value);
      return (selected || classic) && Number.isFinite(quantity) && quantity > 1;
    });
  }

  function syncForm(form) {
    if (!form) return;
    const multiple = hasMultipleQuantity(form);
    form.querySelectorAll('.shopify-payment-button').forEach(widget => {
      if (multiple) {
        if (!previousDisplay.has(widget)) {
          previousDisplay.set(widget, {
            value: widget.style.getPropertyValue('display'),
            priority: widget.style.getPropertyPriority('display'),
            hadStyle: widget.hasAttribute('style')
          });
        }
        if (widget.style.getPropertyValue('display') !== 'none' || widget.style.getPropertyPriority('display') !== 'important') {
          widget.style.setProperty('display', 'none', 'important');
        }
      } else if (previousDisplay.has(widget)) {
        const previous = previousDisplay.get(widget);
        if (previous.value) widget.style.setProperty('display', previous.value, previous.priority);
        else widget.style.removeProperty('display');
        if (!previous.hadStyle && !widget.style.cssText) widget.removeAttribute('style');
        previousDisplay.delete(widget);
      }
    });
  }

  function collectForms(root, forms) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    const collect = element => {
      const form = element.matches('input[name="quantity"]') ? element.form : element.closest('form');
      if (form) forms.add(form);
    };
    if (root.nodeType === 1 && root.matches('.shopify-payment-button, input[name="quantity"]')) collect(root);
    root.querySelectorAll('.shopify-payment-button, input[name="quantity"]').forEach(collect);
    const scope = root.closest?.('product-info, quick-add-modal');
    if (scope) scope.querySelectorAll('.shopify-payment-button').forEach(collect);
  }

  function relevant(node) {
    return node.nodeType === 1 && (node.matches(relevantSelector) || node.querySelector(relevantSelector));
  }

  function start() {
    const forms = new Set();
    collectForms(document, forms);
    forms.forEach(syncForm);

    function quantityChanged(event) {
      const input = event.target;
      if (input.matches?.('input[name="quantity"]')) syncForm(input.form);
    }
    document.addEventListener('change', quantityChanged);
    document.addEventListener('input', quantityChanged);

    new MutationObserver(records => {
      const changedForms = new Set();
      records.forEach(record => {
        record.addedNodes.forEach(node => {
          if (relevant(node)) collectForms(node, changedForms);
        });
        if (Array.from(record.removedNodes).some(relevant)) collectForms(record.target, changedForms);
        const component = record.target.closest?.('.shopify-payment-button, quantity-breaks, quantity-input');
        if (component) collectForms(component, changedForms);
      });
      changedForms.forEach(syncForm);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
